export default __webpack_public_path__ + "media/images/banner/banner-11-04c57e49aab476ce6be2f68dd1471ef5.jpg";